import { useContext, useState } from "react";
import { Button, Nav } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import { Link } from "react-router";

import logo from "../../assets/hourglass-logo-brown.svg";
import HourglassGlobals, { HGContext } from "../../helpers/globals";
import { UnifiedSearch } from "../search/unifiedSearch";
import { WarningModal } from "../warningModal";
import { NavLoggedInUser } from "./loggedInUser";
import { HaveSMPWInvite } from "../smpw/invite";
import { useCongSettings } from "../../api/cong";
import { useTranslation } from "react-i18next";
import { BoxArrowUpRight } from "react-bootstrap-icons";
import { tKey } from "../../helpers/i18n";

//this is the sidebar navigation for desktop/larger screens
function NewNav() {
  const { t } = useTranslation();
  const ctx = useContext(HGContext);
  const congSettings = useCongSettings();
  const [showWarnings, setShowWarnings] = useState(false);
  const clickShowWarnings = () => {
    ctx.setGlobals({ ...ctx.globals, warningsDismissed: false });
    setShowWarnings(true);
  };

  return (
    <>
      <Nav className="top-nav d-flex p-0 d-print-none flex-row">
        {showWarnings && <WarningModal />}

        <Link to="/">
          <div className="brand-label overflow-hidden p-2 d-flex d-md-none">
            <img src={logo} className="top-nav-logo" alt="Hourglass logo" />
          </div>
        </Link>

        <UnifiedSearch variant="compact" id="user-search" className="col col-lg-5 me-auto" />

        <div className="d-flex">
          {!!congSettings.data?.info_board_url && (
            <Button
              className="d-none d-lg-block align-middle"
              onClick={() => {
                window.open(congSettings.data.info_board_url, "_blank");
              }}
              variant="secondary"
              size="sm"
            >
              {t("general.information-board")}
              <BoxArrowUpRight size="1em" className="ms-1 mb-1" style={{ minWidth: "auto" }} />
            </Button>
          )}
          {HourglassGlobals.haveWarnings() && (
            <Button
              className="alert-btn"
              variant="none"
              onClick={clickShowWarnings}
              aria-label={t(tKey("docs.monthsummary.warning.0"))}
            >
              <FaBell />
              <span className="badge rounded-pill badge-notification bg-danger">
                {HourglassGlobals.getWarningsCount()}
              </span>
            </Button>
          )}

          <NavLoggedInUser />
        </div>
      </Nav>
      <HaveSMPWInvite />
    </>
  );
}

export default NewNav;
